import React from 'react';
import { BeatLoader } from 'react-spinners';
 

export default class Loader extends React.Component {
  
  render() {
  
      let displayLoading ={display:"block",width:"100%",backgroundColor:"#c8c9d1",height: "100%"};
      let hideLoading ={display:"none"};

    return (
        
            <div style={this.props.loading ? displayLoading :  hideLoading}>
                <center>
                    <div style={{position: "absolute",
                        marginTop:"-70px",
                        width:"100%",
                        backgroundColor:"#fcfbf7",
                        height: "1200px",
                        opacity: "0.5",}}>
                    <div style={{marginLeft:"-250px",marginTop:"256px",opacity: "100"}} className='sweet-loading'  >
                    <BeatLoader
                    color={'#bb0000'} 
                    loading={this.props.loading} 
                    size={25}
                    margin={"7px"}
                    />
                    </div>
                </div>
                </center>
            </div>
           
            
        
    )
  }
}